import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { css } from 'styled-components';

var _templateObject;
const toolTipStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .tippy-box[data-animation='fade'][data-state='hidden'] {\n    opacity: 0;\n  }\n\n  [data-tippy-root] {\n    max-width: calc(100vw - 10px);\n  }\n\n  .tippy-box {\n    position: relative;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 4px;\n    font-size: ", ";\n    line-height: 1.4;\n    outline: 0;\n    transition-property: transform, visibility, opacity;\n\n    &[data-placement^='top'] > .tippy-arrow {\n      bottom: 0;\n      &:before {\n        bottom: -7px;\n        left: 0;\n        border-width: 8px 8px 0;\n        border-top-color: initial;\n        transform-origin: center top;\n      }\n    }\n\n    &[data-placement^='bottom'] > .tippy-arrow {\n      top: 0;\n      &:before {\n        top: -7px;\n        left: 0;\n        border-width: 0 8px 8px;\n        border-bottom-color: initial;\n        transform-origin: center bottom;\n      }\n    }\n\n    &[data-placement^='left'] > .tippy-arrow {\n      right: 0;\n      &:before {\n        border-width: 8px 0 8px 8px;\n        border-left-color: initial;\n        right: -7px;\n        transform-origin: center left;\n      }\n    }\n\n    &[data-placement^='right'] > .tippy-arrow {\n      left: 0;\n      &:before {\n        left: -7px;\n        border-width: 8px 8px 8px 0;\n        border-right-color: initial;\n        transform-origin: center right;\n      }\n    }\n\n    &[data-inertia][data-state='visible'] {\n      transition-timing-function: cubic-bezier(0.54, 1.5, 0.38, 1.11);\n    }\n  }\n\n  .tippy-arrow {\n    width: 16px;\n    height: 16px;\n    color: ", ";\n    &:before {\n      content: '';\n      position: absolute;\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n\n  .tippy-content {\n    position: relative;\n    padding: 5px 9px;\n    z-index: 1;\n  }\n\n  /* LIGHT */\n  .tippy-box[data-theme~='light'] {\n    color: ", ";\n    box-shadow: 0 0 20px 4px rgba(154, 161, 177, 0.15),\n      0 4px 80px -8px rgba(36, 40, 47, 0.25),\n      0 4px 4px -2px rgba(91, 94, 105, 0.15);\n    background-color: ", ";\n    &[data-placement^='top'] > .tippy-arrow:before {\n      border-top-color: ", ";\n    }\n    &[data-placement^='bottom'] > .tippy-arrow:before {\n      border-bottom-color: ", ";\n    }\n    &[data-placement^='left'] > .tippy-arrow:before {\n      border-left-color: ", ";\n    }\n    &[data-placement^='right'] > .tippy-arrow:before {\n      border-right-color: ", ";\n    }\n    > .tippy-backdrop {\n      background-color: ", ";\n    }\n    > .tippy-svg-arrow {\n      fill: ", ";\n    }\n  }\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.accents.dark;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.text.contrastText;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fontSizes.small;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.accents.dark;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.text;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.background;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colors.background;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.background;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.background;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.colors.background;
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.background;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.colors.background;
});

export { toolTipStyles };
